import { TruncatedTextWithTooltip } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";
import RegionService from "app/services/RegionService";

type Props = {
    regionCode: number;
};

const RegionCellText = ({ regionCode }: Props) => {
    const { name } = RegionService.getRegionById(regionCode.toString());

    return (
        <TruncatedTextWithTooltip
            data-automation="location-text"
            fontVariant="input2"
        >
            {translate(`si.common.region.${name}.label`)}
        </TruncatedTextWithTooltip>
    );
};

export default RegionCellText;
